module.exports = __webpack_public_path__ + "static/media/car-battery.cc698f80.png";